import { FlexRow, Button, AppText } from "src/style";
import { useContext } from "react";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import { Modal } from "../Modal";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import "./index.scss";

const EditUserModal = () => {
  const { visibility, setModal } = useContext(VisibilityContext);
  const { setSubmitEditUser, info } = useContext(AppInfoContext);

  const closeModal = () => {
    setModal({ key: "showEditUserModal", value: false });
  };
  const handleConfirm = () => {
    setSubmitEditUser(!info.submitEditUser);
    setModal({ key: "showEditUserModal", value: false });
  };

  return (
    <Modal
      open={visibility.showEditUserModal}
      cancel={closeModal}
      className="edit-user-modal"
      isOnMenu
    >
      <div className="confirmation">
        <AppText color="black" fontWeight="600" textSize="1.6" align="center">
          Are you sure you want to edit this user?
        </AppText>
      </div>
      <FlexRow justifyContent="space-between" className="btn-container">
        <Button
          hoverColor="#A77B37"
          onClick={closeModal}
          className="edit-user-btn cancel"
        >
          <AiOutlineClose size={17} />
          Cancel
        </Button>
        <Button
          hoverBgColor="#fff"
          hoverColor="#A77B37"
          borderColor="#A77B37"
          className="edit-user-btn confirm"
          onClick={handleConfirm}
        >
          <AiOutlineCheck size={17} /> Confirm
        </Button>
      </FlexRow>
    </Modal>
  );
};
export default EditUserModal;
